module.exports = __webpack_public_path__ + "static/img/scb.046f059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scb.png
// module id = 5Sd5
// module chunks = 0